/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';

/**
 *
 * @class TextEditorMetadata
 *
 * @brief meta data for basic text editor
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class TextEditorMetadata extends DocumentMetadata {

  public key:  string = '/';

  public mode: string = 'text';

  /** standard constructor */
  constructor(
    id:       string = '',
    title:    string = '',
    key:      string = '/',
    mode:     string = 'text',
    icon:     string = '<i class="fas fa-keyboard"></i>',
    type: WindowType = WindowType.TextEditor,
  ) {

    super(id, title, icon, type);

    this.key  = key;
    this.mode = mode;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({key: this.key, mode: this.mode});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.key  = node.key;
    this.mode = node.mode;
  }
}
